import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert, Spinner } from "react-bootstrap";
import { createEnquiry } from "../../api"; // adjust path if needed
import "./enquiry.css";

const Enquiry = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    destination: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  // handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // handle phone input
  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // only digits
    if (value.length <= 10) {
      setFormData({ ...formData, phone: value });
    }
  };

  // handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMsg("");
    setErrorMsg("");

    // check all fields
    if (!formData.name || !formData.email || !formData.phone || !formData.destination || !formData.message) {
      setErrorMsg("Please fill all fields");
      setLoading(false);
      return;
    }

    // phone validation
    if (formData.phone.length !== 10) {
      setErrorMsg("Phone number must be exactly 10 digits");
      setLoading(false);
      return;
    }

    try {
      const res = await createEnquiry(formData);
      console.log("Enquiry Response:", res.data);

      setSuccessMsg("Your enquiry has been submitted successfully!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        destination: "",
        message: "",
      });
    } catch (error) {
      setErrorMsg("Something went wrong. Please try again.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* HERO SECTION */}
      <section className="enquiry-hero">
        <Container>
          <Row>
            <Col md={12}>
              <h1>Plan Your Journey With Us</h1>
              <p>
                Tell us about your travel plans and our team will get back to you
                with the best possible options.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* FORM SECTION */}
      <section className="enquiry-section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="enquiry-box">
                <h3>Travel Enquiry</h3>
                <p className="sub-text">
                  Share your requirements and let BR Travel manage the rest.
                </p>

                {successMsg && <Alert variant="success">{successMsg}</Alert>}
                {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}

                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Enter your name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Email Address</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          placeholder="Enter email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control
                          type="text"
                          name="phone"
                          placeholder="Enter phone number"
                          value={formData.phone}
                          onChange={handlePhoneChange} // updated
                          maxLength={10}
                          required
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Destination</Form.Label>
                        <Form.Control
                          type="text"
                          name="destination"
                          placeholder="Where do you want to go?"
                          value={formData.destination}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-3">
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="message"
                      placeholder="Tell us about your trip requirements"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Button
                    className="enquiry-btn"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />{" "}
                        Submitting...
                      </>
                    ) : (
                      "Submit Enquiry"
                    )}
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Enquiry;
